import { createApp } from 'vue';
const app = createApp(App);
import { initializeApp } from 'firebase/app';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

// main.ts (or similar entry)
import { Capacitor } from '@capacitor/core';

if (Capacitor.getPlatform() === 'web') {
  // Dynamically import the plugin to make sure its web module is pulled in
  import('@capacitor/filesystem').then(async ({ Filesystem }) => {
    try {
      // Any light call works; `getUri` or `checkPermissions` are cheap
      await Filesystem.checkPermissions();
    } catch (_) {
      // Ignore; this is just a warm-up
    }
  });
}

const firebaseConfig = {
  apiKey: 'AIzaSyBZ1yN2PczyaW7pSncx9ljo-rkX94CjwTk',
  authDomain: 'retrylijs.firebaseapp.com',
  databaseURL: 'https://retrylijs-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'retrylijs',
  storageBucket: 'retrylijs.firebasestorage.app',
  messagingSenderId: '589891581794',
  appId: '1:589891581794:web:0ea469d3821aa1b27f1e3b',
  measurementId: 'G-V9MZS4VYJZ',
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firestore
initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

import App from './App.vue';

FirebaseAuthentication.setPersistence({
  persistence: Persistence.BrowserLocal,
});

app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
});

import './style.css';
import router from './router';
import { IonicVue } from '@ionic/vue';
import * as Sentry from '@sentry/vue';
import { VueFire, VueFireAuth } from 'vuefire';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import '@ionic/vue/css/core.css';
import '@fontsource/fredoka-one/index.css';
import '@fontsource/quicksand/index.css';

import { getFiles } from './services/Directus.ts';
import { FirebaseAuthentication, Persistence } from '@capacitor-firebase/authentication';

getFiles();

Sentry.init({
  app,
  dsn: 'https://dbc0d77e75a10141c1a163bbd14231c8@sentry.spellfusion.net/17',
  integrations: [
    Sentry.browserTracingIntegration(),
    /*Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: 'system',
    }),*/
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', 'localhost:5173', 'db.retry.li'],
});

app.use(IonicVue).use(router);

app.mount('#app');
